module.exports = __webpack_public_path__ + "static/media/dannys-marine.946ca2a2.png";